import dayjs from 'dayjs'

type LacquerFormRow = { type?: string; name?: string }

export function normalizeShipmentUpdateData(
    data: Record<string, unknown>
): Record<string, unknown> {
    const next = { ...data }

    const cd = next.clientDeliveryDate
    if (dayjs.isDayjs(cd)) {
        next.clientDeliveryDate = cd.hour(12).minute(0).second(0).millisecond(0).toISOString()
    }

    // Проверяет наличие типа лака, если нет типа, то лак не добавляется в запрос
    if (Array.isArray(next.lacquers)) {
        next.lacquers = next.lacquers.filter(item => {
            if (!item || typeof item !== 'object') {
                return false
            }

            const lacquer = item as LacquerFormRow
            return Boolean(lacquer.type)
        })
    }

    return next
}
